// extracted by mini-css-extract-plugin
export var fadeIn = "_gi-1";
export var modalContent = "_gi-3";
export var overlay = "_gi-0";
export var popoverContent = "_gi-2";
export var results = "_gi-5";
export var searchInputWrapper = "_gi-4";